define('pwa/view/module/menu/MenuClientDataView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Index page view
     *
     * @class MenuClientDataView
     */
    return LayoutView.extend({

        template: '#menu_client_data_view',

        modelEvents: {
            'change': 'render'
        },

    });

});
